<div class="metadata-json-upload">
  <section class="metadata-json-upload__panel" aria-labelledby="metadata-json-upload-schema-label">
    <div class="metadata-json-upload__label-row">
      <label id="metadata-json-upload-schema-label" class="metadata-json-upload__label">
        Metadata JSON <span class="metadata-json-upload__required">*</span>
      </label>
      <div class="metadata-json-upload__download-menu">
        <button
          type="button"
          class="metadata-json-upload__download"
          [attr.aria-expanded]="templateMenuOpen()"
          aria-haspopup="menu"
          (click)="toggleTemplateMenu($event)"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M8 11V2M8 11L5 8M8 11L11 8M2 13.5H14"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Download Template
          <svg
            class="metadata-json-upload__download-chevron"
            [class.metadata-json-upload__download-chevron--open]="templateMenuOpen()"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            aria-hidden="true"
          >
            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        @if (templateMenuOpen()) {
          <div class="metadata-json-upload__download-panel" role="menu" (click)="$event.stopPropagation()">
            <button type="button" role="menuitem" class="metadata-json-upload__download-option" (click)="downloadTemplate('json', $event)">
              JSON
            </button>
            <button type="button" role="menuitem" class="metadata-json-upload__download-option" (click)="downloadTemplate('csv', $event)">
              CSV
            </button>
          </div>
        }
      </div>
    </div>
    <ul class="metadata-json-upload__hint">
      <li>Download the <strong>JSON</strong> or <strong>CSV</strong> template.</li>
      <li>Replace the example values with your dataset details.</li>
      <li>Upload the completed file using the area below.</li>
      <li>Your resource server was already selected in the previous step—you do not need to include it in this file.</li>
      @if (isOgcFeature()) {
        <li class="metadata-json-upload__hint-ogc-feature">
          <strong>OGC Feature requirement:</strong> keep <code>datasetType</code> as
          <strong>"semi Structured"</strong> and <code>fileFormat</code> as
          <strong>"gpkg"</strong> in your file — these values are mandatory and will be
          validated on upload.
        </li>
      }
    </ul>

    @if (!selectedFile()) {
      <div
        class="metadata-json-upload__dropzone"
        [class.metadata-json-upload__dropzone--active]="dragActive()"
        role="button"
        tabindex="0"
        (click)="triggerFileInput()"
        (keydown.enter)="triggerFileInput()"
        (keydown.space)="$event.preventDefault(); triggerFileInput()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <svg class="metadata-json-upload__drop-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="metadata-json-upload__drop-text">
          Drag and drop your JSON or CSV file here or
          <button type="button" class="metadata-json-upload__browse" (click)="triggerFileInput(); $event.stopPropagation()">
            browse
          </button>
        </p>
        <p class="metadata-json-upload__drop-meta">Allowed: JSON, CSV · Max 10MB</p>
        <input
          #fileInput
          type="file"
          class="metadata-json-upload__file-input"
          accept=".json,.csv,application/json,text/csv"
          (change)="onFileSelected($event)"
        />
      </div>
    } @else {
      <div class="metadata-json-upload__file">
        <div class="metadata-json-upload__file-info">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div>
            <p class="metadata-json-upload__file-name">{{ selectedFile()!.name }}</p>
            <p class="metadata-json-upload__file-size">{{ formatFileSize(selectedFile()!.size) }}</p>
          </div>
        </div>
        <button type="button" class="metadata-json-upload__remove" (click)="removeFile()" aria-label="Remove file">
          Remove
        </button>
      </div>
    }

    @if (uploadError()) {
      <div class="metadata-json-upload__error" role="alert">
        <p>{{ uploadError() }}</p>
        @if (missingFields().length > 0) {
          <ul>
            @for (field of missingFields(); track field) {
              <li>{{ field }}</li>
            }
          </ul>
        }
      </div>
    }
  </section>
</div>
